import React, { useEffect } from 'react';
import AddressBlock from '../../components/AddressBlock';
import AddressBlockNewDesign from '../../components/AddressBlock/newAddressBlock';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAddressConfig } from '../../redux/actions/individual-user-flow/individual-user-flow-action';
import { useToggleFeat } from '../../toggleFeature';
import { US, INITIATED, INDIVIDUAL } from '../../utils/constants';

// Used in Add payee page
function AddressBlockContainer(props) {
  useEffect(() => {
    if (props.countryCode) {
      props.triggerGetAddressConfig({ country_code: props.countryCode });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countryCode]);
  const { toggleFeature } = useToggleFeat();
  const { countryCode, status, account_type } = props;
  const isSsnBackNavigatedFlag =
    countryCode === US && status === INITIATED && account_type === INDIVIDUAL;
  return toggleFeature ? (
    <AddressBlockNewDesign
      {...props}
      sectionHead={
        props.personalPageCheck
          ? 'Address'
          : `Recipient’s ${props.account_type !== 'CORPORATE' ? 'residential ' : ''}address`
      }
      isNiumForexUser={props.isNiumForexUser}
    />
  ) : (
    <AddressBlock
      {...props}
      addressConfig={props.addressConfig}
      isSsnBackNavigatedFlag={isSsnBackNavigatedFlag}
    />
  );
}

AddressBlockContainer.propTypes = {
  triggerGetAddressConfig: PropTypes.func.isRequired,

  transactionDetails: PropTypes.object,
  getAllformVal: PropTypes.any,
  isDocsUploadedOrEVerifiedSuccess: PropTypes.bool,
  countryCode: PropTypes.any,
  parent: PropTypes.any,
  personalPageCheck: PropTypes.bool,
  sectionHead: PropTypes.string,
  formSectionName: PropTypes.string,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  countryCodeUrl: PropTypes.string,
  onCountryOfResidenceChange: PropTypes.func,
  renderCountryOfResidence: PropTypes.bool,
  disabledFields: PropTypes.any,
  addressConfig: PropTypes.any,
  account_type: PropTypes.string,
  newSearchUi: PropTypes.bool,
  iconPlacement: PropTypes.string,
  isNiumForexUser: PropTypes.bool,
  boxInputSearchNewUi: PropTypes.bool,
  status: PropTypes.string
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch: (dispatch) => ({ dispatch }),
    triggerGetAddressConfig: (params) => dispatch(getAddressConfig(params))
  };
}
function mapStateToProps(state) {
  const {
    rootReducer: {
      userDataReducer: {
        addressConfig: { data }
      },
      niumForexReducer: { isNiumForexUser },
      userStatusReducer: { status, account_type }
    }
  } = state;
  return {
    addressConfig: data || {},
    isNiumForexUser,
    status,
    account_type
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddressBlockContainer);
